// extracted by mini-css-extract-plugin
export default {"form-group":"RoleForm_form-group__vEadu","detail":"RoleForm_detail__TwhRB","form-actions":"RoleForm_form-actions__VkH1U"};